import React, { useRef, useState, useEffect } from "react";
import { ReactComponent as ImportIcon } from "../../../../assets/import.svg";
import { ReactComponent as ExportIcon } from "../../../../assets/export.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/delete-icon.svg";
import { Row, Col, Button, Popover, Select, message, Progress } from "antd";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { CloseOutlined, DownloadOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import axios from "axios";
import "./index.less";
import UseDocControlPermissions from "../../permissions/useDocControlPermissions";

const { Option } = Select;

const ImportDoc = ({ debounce, project_id }) => {
  const [selectedType, setSelectedType] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadPercent, setUploadPercent] = useState(0);
  const [filename, setFilename] = useState(null);
  const [fileUploaded, setFileUploaded] = useState(null);
  const [importBtnClicked, setImportBtnClicked] = useState(false);
  const [flowCompleted, setFlowCompleted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const { allTemplates } = useSelector((state) => state.materialTemplatesReducer);
  const inputFile = useRef(null);
  const [, canEdit] = UseDocControlPermissions();
  
  // Sample file mapping based on type
  const sampleFiles = {
    material: "Import_Template_-_Material_Control_Register_NEW.xlsx",
    bolts: "Import_Template_-_Bolts_NEW.xlsx",
  };

  const handleDownload = () => {
    let url = `${baseURL}/${filename}`;
    window.open(url, "_blank");
  };
  
  const handleSampleFileDownload = () => {
    if (!selectedType || !sampleFiles[selectedType]) return;
    
    // Use frontend URL (port 3001) instead of baseURL for sample files
    let url = `/sample-files/${sampleFiles[selectedType]}`;
    window.open(url, "_blank");

    // axios
    //   .get(url, {
    //     headers: {
    //       "Content-Type": "application/octet-stream",
    //     },
    //     responseType: "blob",
    //   })
    //   .then((res) => {
    //     // const url = window.URL.createObjectURL(new Blob([res.data]));
    //     // const link = document.createElement("a");
    //     // link.href = url;
    //     // if (typeof window.navigator.msSaveBlob === "function") {
    //     //   window.navigator.msSaveBlob(res.data, filename);
    //     // } else {
    //     //   link.setAttribute("download", filename);
    //     //   document.body.appendChild(link);
    //     //   link.click();
    //     // }

    //     const a = document.createElement("a");
    //     const url = window.URL.createObjectURL(res.data);
    //     a.href = url;
    //     a.download = "name";
    //     a.click();

    //     // var orig_name = res.name_from_db;
    //     // const a = document.createElement("a");
    //     // const url = window.URL.createObjectURL(res.data);
    //     // a.href = url;
    //     // a.download = "name";
    //     // document.body.appendChild(a);
    //     // a.click();
    //   })
    //   .catch((err) => {
    //     console.log("error", err);
    //   });
  };

  const handleSave = async (type) => {
    setSelectedType(type);
    setSuccess(true);
  };

  const cleanupFun = () => {
    setSelectedType(null);
    setSuccess(false);
    setFilename(null);
    setFileUploaded(null);
    setImportBtnClicked(false);
    setFlowCompleted(false);
    setErrorMessage(null);
    setUploadPercent(0);
  };

  const onOpenChange = (e) => {
    if (!e) {
      cleanupFun();
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    cleanupFun();
  };

  useEffect(() => {
    return () => {
      cleanupFun();
    };
  }, []);

  const handleImage = (imgObj, e) => {
    e.currentTarget.value = null;

    const isValid = /\.(xls|xlsx|csv|)$/i.test(imgObj.name);

    if (isValid) {
      if (imgObj) {
        setFileUploaded(imgObj);
      }
    } else {
      message.error("This file format is not supported.");
    }
  };

  const handleImportFile = async () => {
    setLoading(true);
    setErrorMessage(null);
    setUploadPercent(0);

    const fd = new FormData();
    fd.append("documents", fileUploaded);
    fd.append("type", selectedType);
    try {
      const res = await axios.post(
        `${baseURL}/material-control-registers/import/${project_id}`,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      );
      const { status } = res;

      if (status === 200 || status === 201) {
        const { success } = res.data;
        if (success) {
          debounce();
          setFlowCompleted(true);
          setUploadPercent(100);
        } else {
          const error = res.data?.errors || "Import failed";
          setErrorMessage(error);
        }
      } else {
        setErrorMessage("Something went wrong!");
      }
      setLoading(false);
    } catch (error) {
      const errorMsg = error.response?.data?.message || error.message || "Something went wrong!";
      setErrorMessage(errorMsg);
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleDeleteFile = () => {
    setFileUploaded(null);
    setImportBtnClicked(false);
  };

  const CloseBtnSection = () => {
    return (
      <Row justify="center" gutter={[0, 20]} className="close-btn-row">
        <Col span={24}>
          {errorMessage ? (
            <div className="error-text">{errorMessage}</div>
          ) : (
            <div className="success-text">Document Imported Successfully</div>
          )}
        </Col>
        {!errorMessage && (
          <Col span={24} className="done-btn-col">
            <Button size="small" onClick={handleClose} className="done-btn">
              Done
            </Button>
          </Col>
        )}
      </Row>
    );
  };

  const SuccessSection = () => {
    return (
      <Col span={24}>
        {fileUploaded === null ? (
          <Row justify="center" gutter={[0, 20]} className="success-row">
            <Col span={24}>
              <div className="file-text" onClick={handleDownload}>
                {filename}
              </div>
            </Col>
            <Col span={24}>
              {selectedType && (
                <div className="sample-file-link" onClick={handleSampleFileDownload}>
                  Download {selectedType === 'material' ? 'Material' : 'Bolts'} Template
                </div>
              )}
            </Col>
            <Col span={24}>
              <Button
                icon={<ExportIcon />}
                size="small"
                onClick={() => inputFile.current.click()}
                className="upload-btn"
              >
                UPLOAD FILE
              </Button>
              <input
                type="file"
                id="file"
                multiple
                accept=""
                ref={inputFile}
                style={{ display: "none" }}
                onChange={(e) => handleImage(e.target.files[0], e)}
              />
            </Col>
          </Row>
        ) : (
          <Row
            justify="center"
            gutter={[0, 20]}
            className="successfully-uploaded"
          >
            <Col span={24}>
              <div className="disabled-text">{filename}</div>
            </Col>
            <Col span={24} className="file-row">
              <Row>
                <Col span={18}>
                  <div className="file-text" onClick={handleDownload}>
                    {fileUploaded.name}
                  </div>
                  <div className="span-div">
                    <span>File Uploaded Successfully</span>
                  </div>
                </Col>
                <Col>
                  {!flowCompleted && (
                    <DeleteIcon
                      className="del-icon"
                      onClick={handleDeleteFile}
                    />
                  )}
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              {importBtnClicked ? (
                flowCompleted ? (
                  <CloseBtnSection />
                ) : (
                  <Row className="confirm-row" gutter={[0, 20]}>
                    <Col span={24}>
                      {errorMessage ? (
                        <div className="error-text">{errorMessage}</div>
                      ) : (
                        <span className="text-col">
                          You are about to Import the above file into Document
                          Control. Please note this action cannot be undone.
                        </span>
                      )}
                    </Col>
                    {loading && !errorMessage && (
                      <Col span={24}>
                        <span className="text-col">
                          Document is being imported, please wait...
                        </span>
                        <div className="progress-bar">
                          <div className="progress-pulse"></div>
                        </div>
                      </Col>
                    )}
                    {!errorMessage && (
                      <Col span={24} className="btns-col">
                        <Button
                          loading={loading}
                          size="small"
                          onClick={handleImportFile}
                          className="confirm-btn"
                        >
                          Confirm
                        </Button>
                        <Button
                          size="small"
                          onClick={cleanupFun}
                          className="cancel-btn"
                        >
                          Cancel
                        </Button>
                      </Col>
                    )}
                  </Row>
                )
              ) : (
                <Button
                  icon={<ExportIcon />}
                  size="small"
                  onClick={() => setImportBtnClicked(true)} // handleImportFile
                  className="import-file-btn"
                >
                  IMPORT FILE
                </Button>
              )}
            </Col>
          </Row>
        )}
      </Col>
    );
  };

  const UploadFileBtn = () => {
    return (
      <Button
        size="middle"
        icon={<ImportIcon />}
        loading={loading}
        // onClick={handleSave}
        className={`export-btn`}
      >
        UPLOAD FILE
      </Button>
    );
  };

  const Content = () => {
    return (
      <Row justify="center" gutter={[0, 20]} className="parent-div">
        <Col span={24} className="choose-col">
          <div className="choose-select-div">
            <label>{"TYPE"}</label>
            <Row className={flowCompleted ? "readonly-select-row" : ""}>
              <Select
                placeholder="Select Type"
                disabled={flowCompleted}
                size="small"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                onChange={(e) => handleSave(e)}
                value={selectedType}
              >
                <Option value="material" key="material">
                  Material
                </Option>
                <Option value="bolts" key="bolts">
                  Bolts
                </Option>
              </Select>
            </Row>
          </div>
        </Col>
        {success ? (
          <SuccessSection />
        ) : (
          <Col>{filename !== null && <UploadFileBtn />}</Col>
        )}
      </Row>
    );
  };

  const Title = () => {
    return (
      <Row justify="space-between">
        <Col className="title">IMPORT</Col>
        <Col>
          <CloseOutlined onClick={handleClose} />
        </Col>
      </Row>
    );
  };

  return (
    <Popover
      overlayClassName="export-popover"
      placement="topRight"
      getPopupContainer={() =>
        document.getElementsByClassName(
          "ant-layout-content layout-content site-layout-background custom-textarea"
        )[0]
      }
      content={<Content />}
      onOpenChange={onOpenChange}
      title={<Title />}
      trigger="click"
      open={isVisible}
      overlayStyle={{ maxHeight: 'none', height: 'auto', overflow: 'visible' }}
      onVisibleChange={(e) => {
        // Disabled click functionality
        canEdit && setIsVisible(e);
      }}
    >
      <ImportIcon className={canEdit ? "orange-icon" : "orange-icon cursor-not-allowed"} />
    </Popover>
  );
};

export default ImportDoc;
